import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Problem() {
  return <section className="py-20 md:py-32" data-id="element-183">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-184">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-185">
          <div className="md:col-span-5" data-id="element-186">
            <FadeIn data-id="element-187">
              <h2 className="font-serif text-3xl md:text-4xl leading-tight text-teal mb-6" data-id="element-188">
                A esta edad, tu mayor enemigo no son las calorías, <br data-id="element-189" />
                <span className="text-gold italic" data-id="element-190">es el Cortisol.</span>
              </h2>
            </FadeIn>
          </div>

          <div className="md:col-span-1 hidden md:block" data-id="element-191">
            <div className="w-[1px] h-full bg-teal/10 mx-auto" data-id="element-192"></div>
          </div>

          <div className="md:col-span-6" data-id="element-193">
            <FadeIn delay={0.2} data-id="element-194">
              <p className="text-lg text-teal/80 leading-relaxed font-light mb-6" data-id="element-195">
                El estrés crónico, los cambios hormonales y el ritmo de vida
                actual mantienen a tu cuerpo en una{' '}
                <strong data-id="element-196">"alarma constante"</strong>.
              </p>
              <p className="text-lg text-teal/80 leading-relaxed font-light mb-6" data-id="element-197">
                Esa alarma le ordena a tus células guardar agua y acumular grasa
                en el abdomen para protegerte. Por eso, aunque dejes de comer,
                la hinchazón sigue ahí.
              </p>
              <p className="text-lg text-teal/80 leading-relaxed font-light" data-id="element-198">
                Estás viviendo en un cuerpo que se defiende de todo, incluso de
                lo que considerás "saludable".
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}